import axios from 'axios';

export function getTourPrice(payload) {
  return axios.post('/api/price', payload);
}

export function submitOrder(payload) {
  return axios.post('/api/order/create', payload);
}

export function verifyEmail(payload) {
  return axios.post('/api/auth/verify', payload);
}

export function setUserPassword(payload) {
  return axios.post('/api/auth/pass', payload);
}

export function requestPasswordReset(payload) {
  return axios.post('/api/auth/forgot', payload);
}

export function resetPassword(payload) {
  return axios.post('/api/auth/reset', payload);
}

export function changeOrderStage(id, stage, token) {
  return axios.post(
    `/api/order/stage/${id}`,
    { stage },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export function declineOrder(id, token) {
  return axios.post(
    `/api/order/decline/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export function archiveOrder(id, token) {
  return axios.post(
    `/api/order/archive/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export function replaceOrderTour(id, payload, token) {
  return axios.post(`/api/order/replace/${id}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function updateOrderPrice(id, payload, token) {
  return axios.post(`/api/order/price/${id}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function updateOrderFlight(id, payload, token) {
  return axios.post(`/api/order/flight/${id}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function updateOrderContacts(id, payload, token) {
  return axios.post(`/api/order/contacts/${id}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function updateOrderPeople(id, payload, token) {
  return axios.post(`/api/order/people/${id}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function deleteOrder(id, token) {
  return axios.post(
    `/api/order/delete/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export function createAdminOrder(payload, token) {
  return axios.post('/api/order/admin/create', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getSystemSettings() {
  return axios.get('/api/system/settings');
}

export function saveSystemSettings(payload, token) {
  return axios.post('/api/system/settings/save', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getHotelDetailsWithReviews(hotelId) {
  const url = `/api/tv/hotel/reviews/${hotelId}`;

  return axios.get(url);
}

export function getHotelRooms(ids) {
  const query = ids.map((id) => `ids=${id}`).join('&');
  const url = `/api/tv/hotel/rooms?${query}`;

  return axios.get(url);
}

export function getTourDetails(tourId) {
  const url = `/api/tv/tour/${tourId}`;

  return axios.get(url);
}

export function getTourFlights(tourId) {
  const url = `/api/tv/tour/detail/${tourId}`;

  return axios.get(url);
}

export function getOperatorInfo(operatorId) {
  const url = `/api/tv/operators/operator/${operatorId}`;

  return axios.get(url);
}

export function applyCoupon(promoCode) {
  const url = `/api/promo/get/${promoCode}`;

  return axios.get(url);
}

export function addPromo(payload, token) {
  return axios.post('/api/promo/add', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function deletePromo(id, token) {
  return axios.delete(`/api/promo/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getAllUsers(token) {
  return axios.get('/api/user/all', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function deleteUser(id, token) {
  return axios.post(
    `/api/user/delete/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export function fillOrderPeople(id, payload, token) {
  return axios.post(`/api/user/order/${id}/people`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getUserOrders(id, token) {
  return axios.get(`/api/user/${id}/orders`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function hasAdminAccess(token) {
  return axios.get('/api/auth/access', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getHotTours(payload) {
  const url = '/api/tv/search/hot';
  return axios.post(url, payload);
}

export function getHots(payload) {
  const url = '/api/tv/search/hots';
  return axios.post(url, payload);
}

export function initToursSearch(payload) {
  return axios.post('/api/tv/tours/search', payload);
}

export function getToursSearchStatus(searchId) {
  return axios.get(`/api/tv/tours/search/status/${searchId}`);
}

export function getToursSearchReustl(searchId) {
  return axios.get(`/api/tv/tours/search/result/${searchId}`);
}

export function searchLong(searchId) {
  const url = `/api/tv/tours/search/long/${searchId}`;
  return axios.get(url);
}

export function getHotelTypes(countryId) {
  const url = `/api/tv/tours/search/hotel/types/${countryId}`;
  return axios.get(url);
}

export function getHotelToursSearchReustl(searchId) {
  return axios.get(`/api/tv/tours/search/hotel/result/${searchId}`);
}

export function getTourDates(
  departureId,
  countryId,
  arrivalId,
  onlyCharter,
  onlyDirect,
) {
  const url = '/api/tv/tours/dates';
  // axios drops undefined/null params, so optional ones are omitted
  return axios.get(url, {
    params: { departureId, countryId, arrivalId, onlyCharter, onlyDirect },
  });
}
